import { singleParamActionCreator } from '../../lib/singleParamActionCreator'

export const SET_FEATURE = 'SET_FEATURE'

export const setFeature = singleParamActionCreator(SET_FEATURE)
